
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
// import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/support/support.component.ts